
import React, { ReactNode } from "react";
import { CheckCircle2 } from "lucide-react";

interface BenefitItem {
  title: string;
  description: string;
}

interface BenefitsCheckListProps {
  benefits: BenefitItem[];
}

export const BenefitsCheckList: React.FC<BenefitsCheckListProps> = ({ benefits }) => {
  return (
    <div className="mt-8 space-y-4">
      {benefits.map((benefit, index) => (
        <div key={index} className="flex items-start">
          <CheckCircle2 size={24} className="text-dental-highlight mr-3 mt-1 flex-shrink-0" />
          <div>
            <h3 className="text-lg font-medium mb-1">{benefit.title}</h3>
            <p className="text-dental-muted">{benefit.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
